import actionTypes from "constants/modal";
import React, { ReactNode } from "react";
import { Action, handleActions } from "redux-actions";

export type ModalBodyProps = {
    name: string;
    title: string;
    text?: ReactNode;
    body?: string | ReactNode;
    CustomBody?: string | ReactNode | (() => React.JSX.Element);
    buttons?: { confirm?: ReactNode; cancel?: ReactNode };
    action?: () => unknown;
    onCloseAction?: () => void;
};

const { OPEN_MODAL, UPDATE_MODAL, CLOSE_MODAL, ADD_MODAL, CLOSE_ALL_MODAL } = actionTypes;

const initialState: State = { items: [] };

type ModalItemState = ModalBodyProps & { modalId: string };
type State = { items: ModalItemState[] };

let nextModalId = 0;

const createModalItem = (payload: ModalBodyProps): ModalItemState => ({
    ...payload,
    modalId: `modal-${++nextModalId}`,
});

export default handleActions<State, ModalBodyProps>(
    {
        [OPEN_MODAL]: (_state, { payload }: Action<ModalBodyProps>) => ({
            items: [createModalItem(payload)],
        }),
        [UPDATE_MODAL]: (state, { payload }: Action<ModalBodyProps>) => ({
            items: state.items.map((item) => ({ ...item, ...payload, modalId: item.modalId })),
        }),
        [ADD_MODAL]: (state, { payload }: Action<ModalBodyProps>) => ({
            items: [...state.items, createModalItem(payload)],
        }),
        [CLOSE_ALL_MODAL]: () => ({
            items: [],
        }),
        [CLOSE_MODAL]: (state) => {
            const items = [...state.items];
            items.pop();
            return { items };
        },
    },
    initialState,
);
